import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { ITheme } from '../../theme'
import { ItemBadge } from '../../containers/Template/Header/Menu/Notifications/Components/NotificationItem'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const NotificationLabelStyled = styled.div<IWithSize>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: ${({ size }) => (size ? 50 * size : 50)}px;
  border-radius: 0px 0px 6px 6px;
  padding-left: ${({ size }) => (size ? 18 * size : 18)}px;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
  box-shadow: 0 4px 6px -4px #e8e8e8;
`

function NotificationLabel({ count, size = 1 }) {
  const { t } = useTranslation()
  return (
    <NotificationLabelStyled size={size}>
      {t('room_notification_title')}
      <ItemBadge size={size} empty={count <= 0}>
        {count}
      </ItemBadge>
    </NotificationLabelStyled>
  )
}

export default NotificationLabel
